<div class="flex items-center">
  <i class="pi pi-info-circle mr-4 !text-3xl"></i>
  <span class="p-confirm-dialog-message whitespace-pre-line">{{ message }}</span>
</div>

<div class="flex justify-end mt-6">
  <div class="mr-6" *ngIf="!hideCancel">
    <button #btnNo pButton icon="pi pi-times" class="p-button-text" severity="secondary" [label]="cancelLabel"
      (click)="onNoClicked()"></button>
  </div>
  <div class="">
    <p-button icon="pi pi-check" [severity]="confirmSeverity" [label]="confirmLabel"
      (click)="onConfirmClicked()"></p-button>
  </div>
</div>